import { css } from '@emotion/core';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { inputVPadding, inputHPadding, inputBorder, inputBorderRadius, inputTextColor, floatingPaddingTop, floatingPaddingBottom, inputSmallHPadding, inputPlaceholderTextColor, inputHoverBorderColor, inputFocusBorderColor, inputFocusTextColor, inputBorderColor, inputDisabledBackgroundColor, inputErrorBorderColor, inputSmallVPadding, inputSmallFont, inputFont } from './variables';
var textInputStyles = /*#__PURE__*/css("width:100%;max-width:100%;padding:", inputVPadding, "px ", inputHPadding, "px;border:", inputBorder, ";border-radius:", inputBorderRadius, ";", applyFont(inputFont), ";color:", inputTextColor, ";min-width:0;appearance:none;");
var floatingLabel = /*#__PURE__*/css("padding-top:", floatingPaddingTop, "px;padding-bottom:", floatingPaddingBottom, "px;");
var _ref = {
  name: "19t2ho9",
  styles: "display:flex;align-items:stretch;"
};
var _ref2 = {
  name: "79elbk",
  styles: "position:relative;"
};
export var iconWrap = _ref10 => {
  var iconAppearance = _ref10.iconAppearance;
  return /*#__PURE__*/css("position:relative;", iconAppearance === 'outside' ? _ref : _ref2);
};
var iconFirstChildInputFirstChild = {
  name: "tsqr3a",
  styles: "border-top-right-radius:0;border-bottom-right-radius:0;"
};
var iconLastChildInputLastChild = {
  name: "fu3wfu",
  styles: "border-top-left-radius:0;border-bottom-left-radius:0;"
};
var _ref3 = {
  name: "260zpl",
  styles: "left:0;"
};
var _ref4 = {
  name: "19zs6va",
  styles: "right:0;"
};
export var icon = _ref11 => {
  var appearance = _ref11.appearance,
    iconAppearance = _ref11.iconAppearance,
    iconPosition = _ref11.iconPosition,
    isDisabled = _ref11.isDisabled,
    hasIcon = _ref11.hasIcon,
    isInputFirstChild = _ref11.isInputFirstChild;
  return /*#__PURE__*/css("display:flex;align-items:center;padding:0 ", inputHPadding, "px;", appearance === 'small' && /*#__PURE__*/css(applyFont(inputSmallFont), ";padding:0 ", inputSmallHPadding, "px;"), " ", isDisabled && /*#__PURE__*/css("color:", tokens.colors.neutral.heavy.disabled, ";"), " ", iconAppearance === 'outside' ? /*#__PURE__*/css("background:", tokens.colors.neutral.surface.default, ";color:", tokens.colors.neutral.base.default, ";border:", inputBorder, ";border-radius:", inputBorderRadius, ";", hasIcon && !isInputFirstChild && /*#__PURE__*/css("border-right:0;", iconFirstChildInputFirstChild, ";"), " ", hasIcon && isInputFirstChild && /*#__PURE__*/css("border-left:0;", iconLastChildInputLastChild)) : /*#__PURE__*/css("position:absolute;top:0;bottom:0;z-index:2;", iconPosition === 'left' ? _ref3 : _ref4));
};
var _ref5 = {
  name: "1k07npk",
  styles: "border-radius:0;"
};
var _ref6 = {
  name: "fu3wfu",
  styles: "border-top-left-radius:0;border-bottom-left-radius:0;"
};
var _ref7 = {
  name: "tsqr3a",
  styles: "border-top-right-radius:0;border-bottom-right-radius:0;"
};
var _ref8 = {
  name: "q7lffx",
  styles: "opacity:0;"
};
var _ref9 = {
  name: "qcqkus",
  styles: "padding-left:40px;"
};
var _ref0 = {
  name: "19xhq27",
  styles: "padding-right:40px;"
};
export var input = _ref12 => {
  var isInvalid = _ref12.isInvalid,
    appearance = _ref12.appearance,
    isUsingValueRenderer = _ref12.isUsingValueRenderer,
    iconAppearance = _ref12.iconAppearance,
    iconPosition = _ref12.iconPosition,
    hasFloatingLabel = _ref12.hasFloatingLabel,
    isInputFirstChild = _ref12.isInputFirstChild,
    isInputLastChild = _ref12.isInputLastChild,
    resize = _ref12.resize;
  return /*#__PURE__*/css(textInputStyles, ";", !isInputFirstChild && !isInputLastChild && _ref5, " ", isInputLastChild && !isInputFirstChild && _ref6, " ", !isInputLastChild && isInputFirstChild && _ref7, " background:", tokens.colors.neutral.surface.default, ";transition:150ms border-color ease-in,150ms color ease-in,150ms box-shadow ease-in;", isUsingValueRenderer && _ref8, " &::placeholder{color:", inputPlaceholderTextColor, ";font-style:normal;}&:hover{border-color:", inputHoverBorderColor, ";}&:focus{border-color:", inputFocusBorderColor, ";outline:none;color:", inputFocusTextColor, ";box-shadow:inset 0 0 0 1px ", inputFocusBorderColor, ";opacity:1;}&:disabled{border-color:", inputBorderColor, ";background-color:", inputDisabledBackgroundColor, ";&,&::placeholder{color:", tokens.colors.neutral.base.disabled, ";}}", isInvalid && /*#__PURE__*/css("border-color:", inputErrorBorderColor, ";&:focus{border-color:", inputErrorBorderColor, ";box-shadow:inset 0 0 0 1px ", inputErrorBorderColor, ";}&,&:disabled{border-color:", inputErrorBorderColor, ";&:focus{box-shadow:inset 0 0 0 1px ", inputErrorBorderColor, ";}}"), " ", appearance === 'small' && /*#__PURE__*/css(applyFont(inputSmallFont), ";padding:", inputSmallVPadding, " ", inputSmallHPadding, ";"), " ", iconAppearance === 'inside' && (iconPosition === 'left' ? _ref9 : _ref0), " ", !isInputLastChild && /*#__PURE__*/css(iconFirstChildInputFirstChild), " ", hasFloatingLabel && /*#__PURE__*/css(floatingLabel, ";"), " ", resize && /*#__PURE__*/css("resize:", resize, ";"));
};
var _ref1 = {
  name: "1u6u1z0",
  styles: "border-bottom-left-radius:0;border-top-left-radius:0;"
};
export var valueRenderer = _ref13 => {
  var isInvalid = _ref13.isInvalid,
    isDisabled = _ref13.isDisabled,
    isHidden = _ref13.isHidden,
    isDisplayingPlaceholder = _ref13.isDisplayingPlaceholder,
    hasIconLeft = _ref13.hasIconLeft,
    iconPosition = _ref13.iconPosition,
    iconAppearance = _ref13.iconAppearance,
    hasFloatingLabel = _ref13.hasFloatingLabel;
  return /*#__PURE__*/css(textInputStyles, ";position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;overflow:hidden;white-space:nowrap;background-color:", tokens.colors.neutral.surface.default, ";box-shadow:inset 0 0 0 1px transparent;", isInvalid && /*#__PURE__*/css("border-color:", inputErrorBorderColor, ";"), " ", isDisabled && /*#__PURE__*/css("border-color:", inputBorderColor, ";background-color:", inputDisabledBackgroundColor, ";"), " ", isHidden && "\n    opacity: 0;\n  ", " ", isDisplayingPlaceholder && /*#__PURE__*/css("color:", inputPlaceholderTextColor, ";"), " ", hasIconLeft && _ref1, " ", iconAppearance === 'inside' && (iconPosition === 'right' ? /*#__PURE__*/css("padding-right:40px;&::after{display:block;height:40px;width:40px;position:absolute;right:0;bottom:0;top:0;content:' ';background-color:", tokens.colors.neutral.surface.default, ";}") : /*#__PURE__*/css("padding-left:40px;&::before{display:block;height:40px;width:40px;position:absolute;left:0;bottom:0;top:0;content:' ';background-color:", tokens.colors.neutral.surface.default, ";}")), " ", hasFloatingLabel && /*#__PURE__*/css(floatingLabel, ";"));
};